export default __webpack_public_path__ + "static/media/GHSI AFS 2024 W BIR Stamped SEC received (F).934e6b93.pdf";